import { render, staticRenderFns } from "./ApprovalRegionsAlt.vue?vue&type=template&id=6ebf3606&scoped=true"
import script from "./ApprovalRegionsAlt.vue?vue&type=script&lang=js"
export * from "./ApprovalRegionsAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebf3606",
  null
  
)

export default component.exports